import React from 'react';
import {
  MapPin,
  PenTool,
  Map,
  ClipboardCheck,
  LayoutDashboard,
} from 'lucide-react';

// ─────────────────────────────────────────────────────────────────────────────
// localStorage keys
// ─────────────────────────────────────────────────────────────────────────────
export const LAUNCH_TOKEN_KEY     = 'launch_token';
export const LAUNCH_GOOGLE_ID_KEY = 'launch_googleId';
export const LAUNCH_PROFILE_KEY   = 'launch_profile';
export const LAUNCH_EXPIRY_KEY    = 'launch_expiry';

// Google access tokens expiran en 1 hora
export const LAUNCH_SESSION_TTL_MS = 60 * 60 * 1000;

// ─────────────────────────────────────────────────────────────────────────────
// Internal module definition
// ─────────────────────────────────────────────────────────────────────────────
export interface InternalModule {
  id: string;
  name: string;
  description: string;
  path: string;
  icon: React.ElementType;
  color: string;
}

export const MODULE_GEORREF: InternalModule = {
  id: 'georref',
  name: 'Georref',
  description: 'Corrección de datos',
  path: '/document-audit/georeferencing',
  icon: MapPin,
  color: '#0ea5e9',
};

export const MODULE_POLYNATOR: InternalModule = {
  id: 'polynator',
  name: 'Polynator',
  description: 'Creación y edición de polígonos',
  path: '/polygons/dashboard-tools',
  icon: PenTool,
  color: '#7c3aed',
};

export const MODULE_POLYGON_VIEWER: InternalModule = {
  id: 'polygon-viewer',
  name: 'Visor de polígonos',
  description: 'Visualización de polígonos',
  path: '/polygon-viewer/polygon-viewer-dashboard',
  icon: Map,
  color: '#7c3aed',
};

export const MODULE_DOC_REVIEW: InternalModule = {
  id: 'doc-review',
  name: 'Revisión de docs',
  description: 'Auditoría y revisión de documentos',
  path: '/document-audit/tasks',
  icon: ClipboardCheck,
  color: '#f59e0b',
};

export const MODULE_LA_CENTRAL: InternalModule = {
  id: 'la-central',
  name: 'La central',
  description: 'Comité de precios y orquestación',
  path: '/orchestrator-pricing-committee/dashboard-opc',
  icon: LayoutDashboard,
  color: '#10b981',
};

// ─────────────────────────────────────────────────────────────────────────────
// Panel height constants
// ListItem: icon 28px + padding 20px + border 1px = 49px
// PanelHeader ~68px | PanelFooter ~41px
// ─────────────────────────────────────────────────────────────────────────────
export const MAX_COLLAPSED   = 5;
export const MAX_EXPANDED    = 8;
export const ITEM_HEIGHT     = 49;
export const PANEL_HEIGHT    = 68 + MAX_COLLAPSED * ITEM_HEIGHT + 41; // 354px
export const EXPANDED_HEIGHT = 68 + MAX_EXPANDED  * ITEM_HEIGHT + 41; // 501px

// ─────────────────────────────────────────────────────────────────────────────
// Environment display config
// ─────────────────────────────────────────────────────────────────────────────
export const ENV_LABELS: Record<string, string> = {
  local: 'Localhost',
  qa:    'QA (.llavero.co)',
  prod:  'Producción (.habi.co)',
};

export const ENV_COLORS: Record<string, string> = {
  local: '#f59e0b',
  qa:    '#3b82f6',
  prod:  '#10b981',
};
